import * as Parse from 'parse';
import * as React from 'react';
import { Redirect } from 'react-router-dom';

// tslint:disable-next-line:no-shadowed-variable
export default class ViewController<P, S> extends React.Component<P & Interfaces.IViewControllerProps, S & Interfaces.IViewControllerState> {

    constructor(props: any) {
        super(props)
        this.state = {
            loading: false
        } as any;
    }

    // tslint:disable-next-line:no-console
    public telem_render(): JSX.Element { return <div>Empty div</div> }

    public render() {
        const { location } = this.props;
        if (Parse.User.current()) {
            // tslint:disable-next-line:no-unused-expression
            if (location.pathname === '/' || location.pathname.search('sign') !== -1) {
                return <Redirect to="/posts" />
            } else {
                return this.telem_render()
            }
        } else {
            if (location.pathname.search('sign') === -1) {
                // tslint:disable-next-line:no-unused-expression
                return <Redirect to="/signin" />
            } else {
                return this.telem_render()
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/abstract/Controllers/ViewController.tsx